<template>
     <div class='main'>
        <div v-if="showAgreement" class='agreement-part'>
            <AgreementFields/>
        </div>
      
        <div class='main-area' :class="{'no-agreement': showAgreement}" >
            <router-view></router-view>
        </div>
    </div>
</template>

<script setup>
    import { computed, ref, onMounted } from 'vue';
    import { useRouter } from 'vue-router';
    import store from '../store/index.js'
    import AgreementFields from '@/components/AgreementFields.vue';
    const rounter = useRouter()

    const agreement = computed(() => store.state.agreements ? store.state.agreements.find(el => el.type == 'agreement'): null);
    const FIU_Available = computed(() => store.getters.FIU_Available)
    const user = computed(() => store.state.user)
    const showAgreement = computed(() => {
        return (store.state.agreements && store.state.agreements.length && agreement.value && agreement.value.accepted === false)
        //  && userInformation.value && userInformation.value.email_verified && missingUserInfoFields.value.length == 0
    })

    onMounted(() => {
        if (!user.value) {
            rounter.push('/login')
        }
        if (!FIU_Available.value) {
            store.dispatch('addNotification', { text: 'FIU Section is not available, contact support to get more info', type: 'error' })
            rounter.push('/')
        }
    })

</script>

<style scoped lang="scss">
    .agreement-part {
        padding: 20px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
    }

    /* Apply styles to the first direct child element inside when .no-agreement is present */
    // .no-agreement :deep(> :first-child) {
    //     max-height: calc(100vh - 250px);
    // }
</style>